"use client"

import Link from "next/link"
import { useState, useEffect, useMemo } from "react"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"

type SidebarItems = {
  [tag: string]: { title: string; amazonUrl: string }[]
}

interface SidebarProps {
  items: SidebarItems
}

const SidebarForBooks = ({ items }: SidebarProps) => {
  // すべてのタグが開いている状態にするため、初期値を Object.keys(items) に
  const [openCategories, setOpenCategories] = useState<string[]>([])

  // items が変化したら再度すべて開く
  useEffect(() => {
    setOpenCategories(Object.keys(items))
  }, [items])

  // カテゴリを開閉するイベントハンドラ
  const toggleCategory = (category: string) => {
    setOpenCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category],
    )
  }

  // 五十音順にソートしたカテゴリ
  const categories = useMemo(() => {
    return Object.entries(items).sort(([a], [b]) => a.localeCompare(b, "ja"))
  }, [items])

  return (
    <div className="hidden lg:block py-4 px-3">
      {/* タイトル部分 */}
      <h2 className="px-4 text-2xl font-bold tracking-tight pt-2 pb-6">Book</h2>

      {/* アコーディオン */}
      <Accordion
        type="multiple"
        value={openCategories}
        onValueChange={setOpenCategories}
        className="w-full"
      >
        {categories.map(([tag, books]) => (
          <AccordionItem key={tag} value={tag}>
            <AccordionTrigger
              onClick={() => toggleCategory(tag)}
              className="py-4 px-4 text-base font-semibold"
            >
              {tag}
            </AccordionTrigger>
            <AccordionContent>
              <ul className="space-y-1 px-4">
                {books.map((book) => (
                  <li key={book.amazonUrl}>
                    <Link
                      href={book.amazonUrl}
                      className="flex justify-between items-center py-2 px-3 text-sm rounded-md hover:bg-accent hover:text-accent-foreground"
                    >
                      {book.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

export default SidebarForBooks
